import { type CSSProperties, type ReactElement, useEffect, useRef, useState } from 'react'

import { useResize } from '../../hooks/useResize'

export interface MyDropdownProperties {
  overlay: (argument: { hide: () => void }) => ReactElement
  children: ReactElement
  className?: string
  style?: CSSProperties
  visibility?: boolean
  position?: 'right' | 'bottom'
  setVisibility?: (visibility: boolean) => void
  onHide?: () => void
}

export const MyDropdown = ({
  overlay,
  children,
  className,
  style,
  visibility,
  setVisibility,
  onHide,
  position,
}: MyDropdownProperties) => {
  const [visibilityInner, setVisibilityInner] = useState(false)
  const triggerReference = useRef<HTMLDivElement>(null)
  const contentReference = useRef<HTMLDivElement>(null)
  const { ref, rect } = useResize()

  useEffect(() => {
    document.addEventListener(
      'click',

      (e) => {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-argument,@typescript-eslint/no-explicit-any,@typescript-eslint/no-unsafe-type-assertion
        if (triggerReference.current?.contains(e.target as any) ?? false) {
          // trigger要素の内部をクリックした場合は何もしない
          // eslint-disable-next-line @typescript-eslint/no-unsafe-argument,@typescript-eslint/no-explicit-any,@typescript-eslint/no-unsafe-type-assertion
        } else if (contentReference.current?.contains(e.target as any) ?? false) {
          // contentRef要素の内部をクリックした場合も何もしない
        } else if (setVisibility === undefined) {
          setVisibilityInner(false)
          onHide?.()
        } else {
          // XXX: これ、必要な認識だが、これをやると開けなくなる
          // setVisibility(false)
          // onHide?.()
        }
      },
    )
  }, [])

  return (
    <div className={`relative ${className ?? ''}`} ref={ref}>
      <span
        onClick={(e) => {
          if (setVisibility === undefined) {
            setVisibilityInner((x) => !x)
          } else {
            setVisibility(true)
          }
          // closeWithClickOutSideMethod(e)
        }}
        ref={triggerReference}
      >
        {children}
      </span>
      {(visibility ?? visibilityInner) && (
        <div
          className="absolute z-50 bg-white shadow-lg"
          ref={contentReference}
          style={{
            // width: 300,
            ...(position === 'bottom' || position === undefined ? { top: (rect?.height ?? 0) + 2, left: 0 } : {}),
            ...(position === 'right' ? { top: 0, left: (rect?.width ?? 0) + 2 } : {}),
            ...style,
          }}
        >
          {overlay({
            hide: () => {
              if (setVisibility !== undefined) {
                setVisibility(false)
              }
              setVisibilityInner(false)
              // onHide?.()
            },
          })}
        </div>
      )}
    </div>
  )
}
